import { Typography, Box, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

const CasualCard = ({ props, handleClick }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box
            boxShadow={3}
            sx={{
                borderRadius: 2,
                p: 1.5,
                width: '100%',
                background: theme.palette.background.paper,
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            }}
        >
            <Box sx={{ mb: 1.5 }}>
                <Typography
                    variant="h5"
                    sx={{
                        color: theme.palette.text.primary,
                        fontWeight: 700,
                        textAlign: 'left',
                        width: '100%',
                        fontSize: '1.25rem'
                    }}
                >
                    {t(`${props?.Label}`)}
                </Typography>
            </Box>

            <TableContainer sx={{ flex: 1, overflowX: 'hidden', display: 'flex', justifyContent: 'flex-start' }}>
                <Table size="small" sx={{ width: 'auto' }}>
                    <TableBody>
                        {props?.Data?.map((value, index) => (
                            <TableRow
                                key={index}
                                onClick={() => handleClick(value)}
                                sx={{
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                    },
                                    '& td': { borderBottom: 'none' }
                                }}
                            >
                                <TableCell align="right" sx={{ px: 1, py: 1.5 }}>
                                    <Typography
                                        sx={{
                                            color: theme.palette.text.primary,
                                            fontWeight: 700,
                                            fontSize: '1.15rem',
                                            lineHeight: 1.2,
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {value.child[1]?.Value} / {value.child[0]?.Value}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ px: 2, py: 1.5 }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontWeight: 'bold',
                                            fontSize: '0.85rem',
                                            border: '1px solid #99dfe3',
                                            borderRadius: '16px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: 100,
                                            py: 0.5
                                        }}
                                    >
                                        {t(`${value.Datakey}`)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box
                sx={{
                    pt: 1.5,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start'
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.text.secondary,
                        textAlign: 'left',
                        fontSize: '0.75rem'
                    }}
                >
                    {t('Confirmed')} / {t('Total')}
                </Typography>
            </Box>
        </Box>
    );
};

export default CasualCard;
